import MappingField from "./MappingField";
import { appendGetter, removeGetter, updateGetter } from "./array-utils";
import { ClientMappingApiType, ClientMappingField, defaultClientMappingField } from "@avenueops/shared-types";
import { Button } from "@avenueops/web-components";
import React from "react";

interface Props {
  selectedIntegrationId: string;
  integrationData?: any;
  mappingPrefix: string;
  clientMappingApiType: ClientMappingApiType;
  isFirst: boolean;
  level: number;
  fields: ClientMappingField[];
  update: (_: ClientMappingField[]) => void;
  prefix: string;
  notificationPrefix?: string;
}

export default function MappingFieldList({
  selectedIntegrationId,
  integrationData,
  mappingPrefix,
  clientMappingApiType,
  isFirst,
  level,
  fields,
  update,
  prefix,
  notificationPrefix,
}: Props) {
  return (
    <div data-prefix={`${prefix}`} className="flex flex-col w-full">
      <div>
        {(fields as unknown as ClientMappingField[])?.map((field, index) => {
          return (
            <div key={`${index}-${clientMappingApiType}`} className="w-full">
              {field && (
                <MappingField
                  integrationData={integrationData}
                  selectedIntegrationId={selectedIntegrationId}
                  field={field}
                  isFirst={isFirst && index === 0}
                  remove={removeGetter<ClientMappingField>(index, update, fields)}
                  update={updateGetter<ClientMappingField>(index, update, fields)}
                  mappingPrefix={mappingPrefix}
                  clientMappingApiType={clientMappingApiType}
                  level={level + 1}
                  prefix={`${prefix}[${index}]`}
                  notificationPrefix={notificationPrefix}
                />
              )}
            </div>
          );
        })}
      </div>
      <div className="w-fit mb-5">
        <Button type="SECONDARY" onClick={appendGetter<ClientMappingField>(update, fields, defaultClientMappingField)}>
          {`+ Add ${(fields?.length ?? 0) > 0 ? "Another" : ""} Field`}
        </Button>
      </div>
    </div>
  );
}
